module.exports = __webpack_public_path__ + "img/logo_white.37bb0300.png";